import React from 'react';
import { useAtom } from 'jotai';
import { ToastNotification } from '@spins-gcp/shared-components-react';
import { toastAtom } from '../../atoms/toastAtom';
import { ToastVariant } from '../../constants/toast-variant';

export function GlobalToast() {
  const [toast, setToast] = useAtom(toastAtom);

  return (
    <ToastNotification
      show={!!toast}
      variant={toast?.variant ?? ToastVariant.BLANK}
      message={<span>{toast?.message ?? ''}</span>}
      closeHandler={() => setToast(null)}
      delay={3000}
    />
  );
}
